import { ProjectTreeNodeT, SHAPEFILE_TREE_SECTIONS } from "../hooks";

/**
 * Utility function to efficiently filter keys to only shapefile nodes.
 * Optimized to only process manageable tree sections (Project/Organization/EVA Research Shapefiles).
 *
 * @param keys - Array of selected keys to filter
 * @param tree - Full project tree structure
 * @returns Filtered array containing only keys for shapefile/folder nodes that can be managed
 */
export function filterShapefileKeys(keys: string[], tree: ProjectTreeNodeT[]): string[] {
  const shapefileKeys = new Set<string>();

  // Find and process only the manageable tree sections for efficiency
  tree.forEach((rootNode) => {
    if (
      rootNode.key === SHAPEFILE_TREE_SECTIONS.PROJECT ||
      rootNode.key === SHAPEFILE_TREE_SECTIONS.ORGANIZATION ||
      rootNode.key === SHAPEFILE_TREE_SECTIONS.MCDANIEL
    ) {
      // All children in these sections are manageable (layer/folder types with project/org/mcdan sources)
      // No need to check source or type since we're only processing the manageable sections
      const collectAllKeys = (nodes: ProjectTreeNodeT[]) => {
        nodes.forEach((node) => {
          shapefileKeys.add(node.key);

          if (node.children) {
            collectAllKeys(node.children);
          }
        });
      };

      if (rootNode.children) {
        collectAllKeys(rootNode.children);
      }
    }
  });

  return keys.filter((key) => shapefileKeys.has(key));
}
